import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoMarkProps {
    className?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            fill='none'
            stroke='currentColor'
            strokeWidth={1.8}
            strokeLinecap='round'
            strokeLinejoin='round'
            aria-hidden='true'
            className={className}
        >
            <path d='M5.5 14.5 16 6l10.5 8.5' />
            <path d='M8 12.5V23h16V12.5' />
            <path d='M18.5 23v-5.5h3V23' />
            <path d='M11 16.5h4v3h-4z' />
            <path d='M3 23h26' />
            <circle cx='12' cy='26.2' r='2.2' />
            <circle cx='18' cy='26.2' r='2.2' />
        </svg>
    )
}

interface LogoProps {
    className?: string
    tone?: 'dark' | 'light'
}

export const Logo: FC<LogoProps> = ({ className, tone = 'dark' }): ReactNode => {
    return (
        <Link
            href='/'
            className={cn('group inline-flex items-center gap-2.5 rounded-lg outline-none focus-visible:ring-3 focus-visible:ring-ring/40', className)}
            aria-label={`${siteConfig.name} home`}
        >
            <span
                className={cn(
                    'flex size-9 items-center justify-center rounded-xl transition-transform duration-300 group-hover:-rotate-3',
                    tone === 'dark' ? 'bg-primary text-primary-foreground' : 'bg-forest-foreground text-forest'
                )}
            >
                <LogoMark className='size-6' />
            </span>

            <span className='flex flex-col leading-none'>
                <span className={cn('font-heading text-[1.35rem] font-semibold tracking-tight', tone === 'dark' ? 'text-foreground' : 'text-forest-foreground')}>
                    {siteConfig.shortName}
                </span>

                <span className={cn('mt-1 text-[0.62rem] font-semibold tracking-[0.22em] uppercase', tone === 'dark' ? 'text-muted-foreground' : 'text-forest-foreground/60')}>
                    Tiny homes
                </span>
            </span>
        </Link>
    )
}
